const TheATeamData = [
    {
        id: 1,
        bgcolor: '#CDE2DB',
    },
    {
        id: 2,
        bgcolor: '#DDCDE2',
    },
    {
        id: 3,
        bgcolor: "#E4E6D1",
    },
    {
        id: 5,
        bgcolor: "#D0D4DE",
    },
    {
        id: 6,
        bgcolor: "#B8BAD2",
    },
    {
        id: 7,
        bgcolor: "#ECDCDC",
    },
    {
        id: 8,
        bgcolor: "#DCECE0",
    },
    {
        id: 9,
        bgcolor: "#FFF2D7",
    },
    {
        id: 10,
        bgcolor: "#F3F5E0",
    },
    {
        id: 11,
        bgcolor: "#E2FBF8",
    },
    {
        id: 12,
        bgcolor: "#F8E8EE",
    },
    {
        id: 13,
        bgcolor: "#E3F4F4",
    },
    {
        id: 14,
        bgcolor: "#D2E7FF",
    },
];
export default TheATeamData;